import { numberFormat } from 'lib/utils';
import React from 'react';
import styles from './styles.scss';

interface Props {
  description: string;
  amount: number;
}

const CostListItem = ({ description, amount }: Props): JSX.Element => {
  if (!amount) return null;
  return (
    <li className={styles.item}>
      <h2 className={styles.description}>{description}</h2>
      <span className={styles.amount}>{numberFormat.format(amount)},-</span>
    </li>
  );
};

export default CostListItem;
